module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-47.b459bb87.jpg";